import { Machine } from "xstate";
import {
  originalFileUploadStatusIs,
  repairedFileUploadStatusIs,
} from "@/containers/FileRepair/state/guards";
import { IContext, IEvent } from "./types";
import {
  resetFile,
  selectFile,
  setDownloadUrl,
  setUploadedFileName,
  submitFileForm,
} from "./actions";
import {
  fetchDownloadUrl,
  fetchUploadStatusService,
  repairFileService,
  uploadFileService,
} from "./services";

export const fileRepairMachine = Machine<IContext, any, IEvent>({
  id: "repairFileMachine",
  initial: "selectingFile",
  states: {
    selectingFile: {
      on: {
        SELECT_FILE: {
          actions: selectFile,
          target: "droppedFile",
        },
      },
    },
    droppedFile: {
      on: {
        SUBMIT_FILE_FORM: {
          actions: submitFileForm,
          target: "uploading",
        },
        RESET_FILE: {
          actions: resetFile,
          target: "selectingFile",
        },
      },
    },
    uploading: {
      invoke: {
        src: uploadFileService,
      },
      on: {
        SET_UPLOADED_FILE_NAME: {
          actions: setUploadedFileName,
          target: "pollingUploadStatus",
        },
      },
    },
    pollingUploadStatus: {
      invoke: {
        src: fetchUploadStatusService,
      },
      on: {
        SET_UPLOAD_PROGRESS: [
          {
            cond: originalFileUploadStatusIs("done"),
            target: "preview",
          },
          {
            cond: originalFileUploadStatusIs("failed"),
            target: "error",
          },
        ],
      },
    },
    preview: {
      on: {
        REPAIR_FILE: "repair",
      },
    },
    repair: {
      invoke: {
        src: repairFileService,
        onDone: "pollingRepairedFileUploadStatus",
      },
    },
    pollingRepairedFileUploadStatus: {
      invoke: {
        src: fetchUploadStatusService,
      },
      on: {
        SET_UPLOAD_PROGRESS: [
          {
            cond: repairedFileUploadStatusIs("done"),
            target: "fetchingDownloadUrl",
          },
          {
            cond: repairedFileUploadStatusIs("failed"),
            target: "error",
          },
        ],
      },
    },
    fetchingDownloadUrl: {
      invoke: {
        src: fetchDownloadUrl,
        onError: "error",
      },
      on: {
        SET_DOWNLOAD_URL: {
          actions: setDownloadUrl,
          target: "repairedFilePreview",
        },
      },
    },
    repairedFilePreview: {
      on: {
        REPAIR_ANOTHER_FILE: {
          actions: resetFile,
          target: "selectingFile",
        },
      },
    },
    error: {},
  },
});
